/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import React from 'react';
import { ContentErrorBoundary } from '@features/error';

interface Props {
  Header?: JSX.Element;
  context?: object;
  className?: string;
}

const initialContextState = {};

const AppLayoutContext = React.createContext(initialContextState);

export const AppLayout: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const { context = initialContextState } = props;

  return (
    <AppLayoutContext.Provider value={context} >
      {props.Header}
      <ContentErrorBoundary>
        <div className={`main d-flex ${props.className ?? ''}`}>
          {props.children}
        </div>
      </ContentErrorBoundary>
    </AppLayoutContext.Provider>
  )
}
